export default "__VITE_ASSET__283c7af0__"